import { render, staticRenderFns } from "./PageAdminOpportunities.vue?vue&type=template&id=1b86c453"
import script from "./PageAdminOpportunities.vue?vue&type=script&lang=js"
export * from "./PageAdminOpportunities.vue?vue&type=script&lang=js"
import style0 from "./PageAdminOpportunities.vue?vue&type=style&index=0&id=1b86c453&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports